export { default } from './SimpleField';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/SimpleField/index.js